export enum actionTypes {
  AREAS_FETCH = 'AREAS_FETCH',
  AREAS_SUCCESS = 'AREAS_SUCCESS',
  AREAS_ERROR = 'AREAS_ERROR',
  AREAS_RESET = 'AREAS_RESET',
}

export enum AreasStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Area {
  id: number
  nombre: string
}

export interface AreasState {
  idPais?: number
  status: AreasStatus
  areas: Array<Area>
}

export interface AreasFetch {
  type: typeof actionTypes.AREAS_FETCH
  payload: { idPais }
}

export interface AreasSuccess {
  type: typeof actionTypes.AREAS_SUCCESS
  payload: { areas }
}

export interface AreasError {
  type: typeof actionTypes.AREAS_ERROR
  payload: null
}

export interface AreasReset {
  type: typeof actionTypes.AREAS_RESET
  payload: null
}

export type AreasActions = AreasFetch | AreasSuccess | AreasError | AreasReset

export const initialState: AreasState = {
  status: AreasStatus.Idle,
  areas: [],
}
